import React, { useMemo } from "react";

/*
 * Green particles rising smoothly upwards (betjuicy-style embers)
 * Rendered inside an absolutely-positioned, overflow-hidden parent.
 */
const Particles = ({ count = 20 }) => {
  const parts = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: Math.random() * 100,
        size: 2 + Math.random() * 4.5,
        dur: 7 + Math.random() * 9,
        delay: Math.random() * 10,
        drift: -30 + Math.random() * 60,
        o: 0.3 + Math.random() * 0.55,
      })),
    [count]
  );

  return (
    <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
      {parts.map((p, i) => (
        <span
          key={i}
          className="rise-particle"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            "--dur": `${p.dur}s`,
            "--delay": `${p.delay}s`,
            "--drift": `${p.drift}px`,
            "--o": p.o,
          }}
        />
      ))}
    </div>
  );
};

export default Particles;
